import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var ViewEvent = /** @class */ (function (_super) {
    __extends(ViewEvent, _super);
    function ViewEvent(type, view) {
        var _this = _super.call(this, type) || this;
        _this._view = view;
        return _this;
    }
    Object.defineProperty(ViewEvent.prototype, "view", {
        get: function () {
            return this._view;
        },
        enumerable: false,
        configurable: true
    });
    ViewEvent.INVALIDATE_VIEW_MATRIX3D = 'invalidateViewMatrix3D';
    ViewEvent.INVALIDATE_SIZE = 'invalidateSize';
    return ViewEvent;
}(EventBase));
export { ViewEvent };
